function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.stp{clip-path:url(#SVGID_2_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  width: 45,
  height: 45.7
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M0.9,35.4C0.4,35.4,0,35,0,34.5V15.7c0-0.5,0.4-0.9,0.9-0.9H40c0.5,0,0.9,0.4,0.9,0.9v2.3 c0,0.5-0.4,0.9-0.9,0.9h0c-0.5,0-0.9-0.4-0.9-0.9v-1.5H1.7v17.1h20.9c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9H0.9z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M40,18.8c0.4,0,0.7-0.3,0.7-0.7v0v-2.3c0-0.4-0.3-0.7-0.7-0.7h0H0.9c-0.4,0-0.7,0.3-0.7,0.7v0v18.8 c0,0.4,0.3,0.7,0.7,0.7h0h21.7c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7H1.5V16.4h37.8v1.7C39.3,18.5,39.6,18.8,40,18.8 L40,18.8z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M2.4,13.5c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.4-0.2-0.5-0.4c-0.1-0.2-0.2-0.4-0.1-0.7l1.6-7C3.2,5.2,3.3,5,3.5,4.8 C3.7,4.7,3.8,4.7,4,4.7c0.1,0,0.1,0,0.2,0l31.3,7c0.4,0.1,0.7,0.4,0.7,0.8c0,0.2-0.1,0.4-0.3,0.6c-0.2,0.2-0.4,0.3-0.6,0.3h0 c-0.1,0-0.1,0-0.2,0L4.7,6.6l-1.4,6.2C3.2,13.2,2.8,13.5,2.4,13.5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M3.6,5C3.5,5.1,3.4,5.2,3.3,5.4l-1.6,7c-0.1,0.4,0.1,0.7,0.5,0.8c0.4,0.1,0.7-0.1,0.8-0.5l1.4-6.4l30.7,6.9 c0,0,0.1,0,0.1,0c0.4,0,0.7-0.3,0.7-0.7c0-0.3-0.2-0.6-0.5-0.7l-31.3-7C4,4.9,3.8,4.9,3.6,5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M31.4,9.6c-0.1,0-0.2,0-0.3-0.1L13,2l-1.2,2.4l0,0c0,0,0,0,0,0c-0.2,0.3-0.4,0.5-0.8,0.5c-0.1,0-0.3,0-0.4-0.1 c-0.2-0.1-0.4-0.3-0.4-0.5c-0.1-0.2,0-0.5,0.1-0.7l1.6-3.1C12,0.2,12.3,0,12.6,0c0.1,0,0.2,0,0.3,0.1l18.8,7.8 c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.1,0.5,0,0.7C32.1,9.4,31.7,9.6,31.4,9.6"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M11.6,4.3l1.3-2.6l18.2,7.6c0.3,0.1,0.7,0,0.9-0.4c0.1-0.3,0-0.7-0.4-0.9L12.9,0.2c-0.3-0.1-0.7,0-0.9,0.3 l-1.6,3.1c-0.2,0.3-0.1,0.7,0.3,0.9C11,4.8,11.4,4.7,11.6,4.3C11.6,4.3,11.6,4.3,11.6,4.3L11.6,4.3z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M25.9,19.7c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h6.2c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9 H25.9z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M32.8,18.9c0-0.4-0.3-0.7-0.7-0.7h-6.2c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7h6.2 C32.5,19.5,32.8,19.2,32.8,18.9"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M19.7,32.2c-3.9,0-7.1-3.2-7.1-7.1c0-3.9,3.2-7.1,7.1-7.1c3.9,0,7.1,3.2,7.1,7.1C26.7,29,23.6,32.2,19.7,32.2 L19.7,32.2z M19.7,19.7c-3,0-5.4,2.4-5.4,5.4c0,3,2.4,5.4,5.4,5.4c3,0,5.4-2.4,5.4-5.4S22.7,19.7,19.7,19.7L19.7,19.7z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M19.7,32c3.8,0,6.9-3.1,6.9-6.9s-3.1-6.9-6.9-6.9s-6.9,3.1-6.9,6.9C12.8,28.9,15.9,32,19.7,32 M19.7,19.5 c3.1,0,5.6,2.5,5.6,5.6c0,3.1-2.5,5.6-5.6,5.6S14,28.3,14,25.1C14,22,16.5,19.5,19.7,19.5"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M36.2,45.7c-4.4,0-8.8-1-8.8-3.3V23.6c0-2.3,4.4-3.3,8.8-3.3s8.8,1,8.8,3.3v18.8C45,44.7,40.6,45.7,36.2,45.7  M29.3,42.3c0.2,0.4,2.5,1.4,6.8,1.4c4.3,0,6.7-1.1,6.8-1.4v-0.9c-1.6,0.7-4.1,1.1-6.8,1.1c-2.7,0-5.3-0.4-6.8-1.1V42.3z  M29.3,39.2c0.2,0.4,2.5,1.4,6.8,1.4c4.3,0,6.7-1.1,6.8-1.4v-0.9c-1.6,0.7-4.1,1.1-6.8,1.1c-2.7,0-5.3-0.4-6.8-1.1V39.2z  M29.3,36.1c0.2,0.4,2.5,1.4,6.8,1.4c4.3,0,6.7-1.1,6.8-1.4v-0.9c-1.6,0.7-4.1,1.1-6.8,1.1c-2.7,0-5.3-0.4-6.8-1.1V36.1z  M29.3,32.9c0.2,0.4,2.5,1.4,6.8,1.4c4.3,0,6.7-1.1,6.8-1.4V32c-1.6,0.7-4.1,1.1-6.8,1.1c-2.7,0-5.3-0.4-6.8-1.1V32.9z M29.3,29.8 c0.2,0.4,2.5,1.4,6.8,1.4c4.3,0,6.7-1.1,6.8-1.4v-0.9c-1.6,0.7-4.1,1.1-6.8,1.1c-2.7,0-5.3-0.4-6.8-1.1V29.8z M29.3,26.7 c0.2,0.4,2.5,1.4,6.8,1.4c4.3,0,6.7-1.1,6.8-1.4v-0.9c-1.6,0.7-4.1,1.1-6.8,1.1c-2.7,0-5.3-0.4-6.8-1.1V26.7z M29.4,23.6 c0.3,0.3,2.5,1.4,6.8,1.4c4.2,0,6.5-1,6.8-1.4c-0.4-0.4-2.7-1.4-6.8-1.4C32,22.2,29.7,23.2,29.4,23.6"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M36.2,20.4c-4.1,0-8.6,1-8.6,3.1v18.8c0,2.2,4.5,3.1,8.6,3.1s8.6-1,8.6-3.1V23.6 C44.8,21.4,40.3,20.4,36.2,20.4 M43.2,39.2c-0.1,0.4-2.5,1.6-7,1.6s-6.9-1.1-7-1.6V38c1.7,0.8,4.4,1.2,7,1.2s5.4-0.4,7-1.2V39.2z  M43.2,36.1c-0.1,0.4-2.5,1.6-7,1.6s-6.9-1.1-7-1.6v-1.2c1.7,0.8,4.4,1.2,7,1.2s5.4-0.4,7-1.2V36.1z M43.2,33 c-0.1,0.4-2.5,1.6-7,1.6s-6.9-1.1-7-1.6v-1.2c1.7,0.8,4.4,1.2,7,1.2s5.4-0.4,7-1.2V33z M43.2,29.8c-0.1,0.4-2.5,1.6-7,1.6 s-6.9-1.1-7-1.6v-1.2c1.7,0.8,4.4,1.2,7,1.2s5.4-0.4,7-1.2V29.8z M43.2,26.7c-0.1,0.4-2.5,1.6-7,1.6s-6.9-1.1-7-1.6v-1.2 c1.7,0.8,4.4,1.2,7,1.2s5.4-0.4,7-1.2V26.7z M36.2,22c4.5,0,6.9,1.1,7,1.6c-0.2,0.4-2.5,1.6-7,1.6c-4.6,0-6.9-1.1-7-1.6v0 C29.3,23.1,31.6,22,36.2,22 M36.2,43.9c-4.6,0-6.9-1.1-7-1.6v-1.2c1.7,0.8,4.4,1.2,7,1.2s5.4-0.4,7-1.2v1.2 C43.1,42.8,40.8,43.9,36.2,43.9"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M7.2,32.3c-0.2,0-0.5-0.1-0.6-0.3l-3.2-3.5c-0.1-0.2-0.2-0.4-0.2-0.6v-5.6c0-0.2,0.1-0.5,0.2-0.7l0,0l3.5-3.4 C7.1,18.1,7.3,18,7.5,18h5.9c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9H7.8l-3,2.9v4.9l2.7,2.9h5.8c0.5,0,0.9,0.4,0.9,0.9 c0,0.5-0.4,0.9-0.9,0.9H7.2z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "stp",
  d: "M7.8,19.5h5.6c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7H7.5c-0.2,0-0.3,0.1-0.5,0.2l-3.5,3.4 c-0.1,0.2-0.2,0.3-0.2,0.5v5.6c0,0.2,0.1,0.3,0.2,0.5l3.2,3.5C6.8,32,7,32.1,7.2,32.1h6.2c0.4,0,0.7-0.3,0.7-0.7 c0-0.4-0.3-0.7-0.7-0.7H7.5l-2.8-3.1v-5.1L7.8,19.5z"
});

var SvgPaymentIcon = function SvgPaymentIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45.7px",
    viewBox: "0 0 45 45.7",
    style: {
      enableBackground: "new 0 0 45 45.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaymentIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment-icon.206c7017.svg";
export { ForwardRef as ReactComponent };